import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";

import styles from "./index.module.scss";

export interface LearnMoreProps {
  text?: string;
  link: string;
  onClick?: (e: any) => void;
}

export function LearnMore(props: LearnMoreProps) {
  const { text = "了解更多", link, onClick } = props;

  return (
    <span className={styles["learn-more"]}>
      <a href={link} target="_blank" onClick={(e) => onClick?.(e)}>
        {text}
      </a>
      <FontAwesomeIcon icon={faAngleRight} style={{ marginLeft: "5px" }} />
    </span>
  );
}
